export default "/images/credit-card.png";